import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils, type InterfaceInputToken } from '@morpho-org/dapp-core';
import { MarketIdentity } from '@morpho-org/ui-v6/client';
import { UNKNOWN_SYMBOL } from '@morpho-org/ui-v6/utils';
import { InternalLink } from '@/components/common/InternalLink';
import { getMarketUrl } from '@/helpers/routing';
interface InlineMarketLinkProps {
  market: {
    marketId: MarketId;
    collateralAsset: InterfaceInputToken | null;
    loanAsset: InterfaceInputToken;
  };
}
const InlineMarketLink = t0 => {
  const $ = _c(11);
  const {
    market
  } = t0;
  const {
    collateralAsset,
    loanAsset
  } = market;
  const {
    marketId
  } = market;
  const chainId = loanAsset.chain.id;
  let t1;
  if ($[0] !== chainId || $[1] !== collateralAsset?.symbol || $[2] !== loanAsset.symbol || $[3] !== marketId) {
    const identifier = InterfaceChainUtils.getIdentifierById(chainId);
    const collateralSymbol = collateralAsset?.symbol ?? UNKNOWN_SYMBOL;
    const loanSymbol = loanAsset.symbol ?? UNKNOWN_SYMBOL;
    t1 = getMarketUrl({
      identifier,
      marketId,
      collateralSymbol,
      loanSymbol
    });
    $[0] = chainId;
    $[1] = collateralAsset?.symbol;
    $[2] = loanAsset.symbol;
    $[3] = marketId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const href = t1;
  const t2 = collateralAsset ?? undefined;
  let t3;
  if ($[5] !== loanAsset || $[6] !== t2) {
    t3 = <MarketIdentity loanAsset={loanAsset} collateralAsset={t2} textClassName="text-xs" />;
    $[5] = loanAsset;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== href || $[9] !== t3) {
    t4 = <InternalLink className="gap-2xs px-xs py-2xs text-foreground hover:bg-accent inline-flex items-center rounded-[100px] no-underline" href={href} onClick={_temp}>{t3}</InternalLink>;
    $[8] = href;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default InlineMarketLink;
function _temp(e) {
  return e.stopPropagation();
}